export const environment = {
  production: false,
  apiUrl: 'https://sso-backend.supplyvalid.in'
};
